import { Button, Modal, Typography } from '@tractian/ui'
import { PlayCircleIcon } from '@tractian/icons'

import { useSubmitAssessment } from '@/features/assessments/api/assessment-submit'
import type { PlantAssessment } from '@/features/assessments/api/assessment-list'

export type StartAssessmentModalProps = {
  open: boolean
  onClose: () => void
  assessment: PlantAssessment | undefined
}

export function StartAssessmentModal({ open, onClose, assessment }: StartAssessmentModalProps) {
  const submitMutation = useSubmitAssessment()

  function handleConfirm() {
    if (!assessment) return
    submitMutation.mutate(assessment.id, {
      onSuccess: () => {
        onClose()
      },
    })
  }

  return (
    <Modal open={open} onOpenChange={(next) => !next && onClose()}>
      <Modal.Content classes={{ content: 'h-fit w-[500px]' }}>
        <Modal.Header>
          <div className="flex items-center gap-2">
            <PlayCircleIcon className="text-blue-500" />
            <Typography.Heading size="medium">{assessment?.plantName}</Typography.Heading>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Typography.Text>
            Starting this assessment will move it to In Progress.
          </Typography.Text>
        </Modal.Body>
        <Modal.Footer>
          <Modal.FooterActions>
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={submitMutation.isPending}
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={handleConfirm}
              loading={submitMutation.isPending}
            >
              Start
            </Button>
          </Modal.FooterActions>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
